import { useEffect, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import styles from "./style.module.scss";
import BarcodeGeneratorForm from "@components/dynamic/BarcodeGeneratorForm";

type ProductGenerateBarcodeProps = {
}


const ProductGenerateBarcode = (props: ProductGenerateBarcodeProps) => {
  useEffect(() => {

  },);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Generar Codigos de barra"
      backUrl="/user/products"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "productForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <BarcodeGeneratorForm />

    </PageContainer>
  );
}

export default ProductGenerateBarcode;
